import { ContestTaskType } from '../contest/ContestTask';

export class School {
  public id: string;
  public name: string;
  public type!: string;

  public short_name!: string;

  public region_id?: string;
  public region_name?: string;
  public address?: string;

  public phone?: string;
  public email?: string;
  public website?: string;

  public contact_name?: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  public static parse(data: SchoolDto): School {
    const school = new School(data.id, data.name);

    school.type = data.type;
    school.short_name = data.short_name || '';

    school.region_id = data.region_id;
    school.region_name = data.region_name;
    school.address = data.address;

    school.phone = data.phone;
    school.email = data.email;
    school.website = data.website;
    school.contact_name = data.contact_name;

    return school;
  }
}

export class SchoolType {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  public static parse(data: SchoolTypeDto): SchoolType {
    return new SchoolType(data.id, data.name);
  }
}

export interface SchoolTypeDto {
  id: string;
  name: string;
}

export interface SchoolBaseDto {
  id: string;
  name: string;
  short_name?: string;
}

export interface SchoolDto extends SchoolBaseDto {
  type: string;

  region_id?: string;
  region_name?: string;
  address?: string;

  phone?: string;
  email?: string;
  website?: string;

  contact_name?: string;
}

export enum SchoolGrade {
  second = '2',
  third = '3',
  forth = '4',
  fifth = '5',
  sixth = '6',
  seventh = '7',
  eighth = '8',
  ninth = '9',
  tenth = '10',
  eleventh = '11'
}

export class SchoolGradeEx {
  grade: SchoolGrade;
  type?: ContestTaskType;

  constructor(grade: SchoolGrade, type?: ContestTaskType) {
    this.grade = grade;
    this.type = type;
  }
}

export function localizeSchoolGrade(grade: SchoolGrade): string {
  let value: string = '';

  switch (grade) {
    case SchoolGrade.second:
      value = $localize`:General|School Grade 2 title@@general-school-grade-2-title:2nd grade`;
      break;
    case SchoolGrade.third:
      value = $localize`:General|School Grade 3 title@@general-school-grade-3-title:3rd grade`;
      break;
    case SchoolGrade.forth:
      value = $localize`:General|School Grade 4 title@@general-school-grade-4-title:4th grade`;
      break;
    case SchoolGrade.fifth:
      value = $localize`:General|School Grade 5 title@@general-school-grade-5-title:5th grade`;
      break;
    case SchoolGrade.sixth:
      value = $localize`:General|School Grade 6 title@@general-school-grade-6-title:6th grade`;
      break;
    case SchoolGrade.seventh:
      value = $localize`:General|School Grade 7 title@@general-school-grade-7-title:7th grade`;
      break;
    case SchoolGrade.eighth:
      value = $localize`:General|School Grade 8 title@@general-school-grade-8-title:8th grade`;
      break;
    case SchoolGrade.ninth:
      value = $localize`:General|School Grade 9 title@@general-school-grade-9-title:9th grade`;
      break;
    case SchoolGrade.tenth:
      value = $localize`:General|School Grade 10 title@@general-school-grade-10-title:10th grade`;
      break;
    case SchoolGrade.eleventh:
      value = $localize`:General|School Grade 11 title@@general-school-grade-11-title:11th grade`;
      break;

  }

  return value;
}
